"use strict";
var r, n;
function p() {
  return n || (n = 1, r = Function.prototype.apply), r;
}
export {
  p as __require
};
//# sourceMappingURL=index.es323.js.map
